<template>
<!--  https://chenxuan0000.github.io/vue-seamless-scroll/zh/guide/-->
  <div class="cpjsBox" :style="{backgroundImage:'url('+itemData.backgroundImage+')'}">
<!--    <div class="cpjs_left_i cpjs_i" @click="leftYY" :style="{ backgroundColor: colorData.left }">-->
<!--      <div class="circle-container">-->
<!--        <i class="el-icon-arrow-left"></i>-->
<!--      </div>-->
<!--    </div>-->
    <div class="cpjs_ze">
    <div class="cpjsHeader">
      <div class="cpjs_left">{{itemData.cpjsTitle}}</div>
      <div class="cpjs_right" @click="cpjsCK">{{itemData.cpjsMore}}</div>
    </div>
    <div class="cpjsContentBox">
      <div class="cpjs_item"  v-show="item.showData" v-for="item in itemData.cpjsItem" @click="toCpjs(item.path)">
          <div class="cpjs_item_img">
<!--            <el-image
              style="width: 376px; height: 360px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
border-bottom: 2px solid #5daf34;"
              :src=""
              :fit="contain"></el-image>-->
            <img :src="item.imgUrl" alt="">
          </div>
        <div class="cpjs_item_text1">
          {{item.text1}}
        </div>
        <div class="cpjs_item_text2">
          {{item.text2}}
        </div>
      </div>
    </div>
    </div>
<!--    <div class="cpjs_right_i" @click="rightYY" :style="{ backgroundColor: colorData.right }">-->
<!--      <i class="el-icon-arrow-right cpjs_i"></i>-->
<!--    </div>-->
  </div>
</template>

<script>
import { Data } from '../js/image/cpjs'
export default {
  name: "cpjs",
  data() {
    return {
      dataAll: Data,
      itemData: {},
      indexUrl: 1,
      colorData:{
        right:"#5daf34",
        left:"#FFFFFF"
      },
      listData: [1, 2, 3, 4, 5, 6],
      classOption: {
        limitMoveNum: 2,
        switchSingleStep: 428,
        direction: 2,
        // autoPlay:false,
        navigation:true
      },

    }
  },
  created() {
    let that = this;
    console.log(that.urlData);
    that.indexUrl = that.$route.query.index;
    console.log(that.urlData);
  },
  mounted() {
    let that = this;
    console.log(2344322)
    for(let index in that.dataAll){
      console.log(234432233)
      console.log(that.$parent.$parent.message)

      let itemData= that.dataAll[index];
      if(that.$parent.$parent.message == itemData.type){

        console.log(23443223366)

        that.itemData = itemData;
        break;
      }
    }
    that.init();

  },
  methods:{
    init(){
      let that = this;
      if(that.indexUrl != '' && that.indexUrl != undefined) {
        if(that.indexUrl +2 >  that.cpjsItem.length) {
          for (var i = 0; i < that.cpjsItem.length; i++) {
            let item = that.cpjsItem[i];
            if(i>=(that.indexUrl-1) && i<=(that.indexUrl+2)){
              item.showData = true;
            } else {
              item.showData = false;
            }
          }
          if(that.indexUrl > 1){
            this.colorData.left = '#5daf34'
          } else {
            this.colorData.left = '#FFFFFF'
          }
          if(that.cpjsItem.length > that.indexUrl+2){
            this.colorData.right = '#5daf34'
          } else {
            this.colorData.left = '#FFFFFF'
          }
        } else {
          for (var i = 0; i < that.cpjsItem.length; i++) {
            let item = that.cpjsItem[i];
            if(i<3){
              item.showData = true;
            } else {
              item.showData = false;
            }
          }

          this.colorData.left = '#FFFFFF'

          if(that.cpjsItem.length > 3){
            this.colorData.right = '#5daf34'
          } else {
            this.colorData.left = '#FFFFFF'
          }
        }
      } else {
        that.indexUrl = 1;
        for (var i = 0; i < that.cpjsItem.length; i++) {
          let item = that.cpjsItem[i];
          if(i<3){
            item.showData = true;
          } else {
            item.showData = false;
          }
        }

        this.colorData.left = '#FFFFFF'
        console.log('ttxxx'+that.cpjsItem.length)
        if(that.cpjsItem.length > 3){
          this.colorData.right = '#5daf34'
        } else {
          this.colorData.right = '#FFFFFF'
        }
      }
      console.log(that.indexUrl)
    },
    leftYY(){
      console.log("left")
      let that = this;
      if(that.indexUrl === 1){
        return;
      } else {
        let indexBB = that.indexUrl-1;
        for (var i = 0; i < that.cpjsItem.length; i++) {
          let item = that.cpjsItem[i];
          if(i>=(indexBB-1) && i<(indexBB+2)){
            item.showData = true;
          } else {
            item.showData = false;
          }
        }
        if(indexBB > 1){
          this.colorData.left = '#5daf34'
        } else {
          this.colorData.left = '#FFFFFF'
        }
        if(that.cpjsItem.length > indexBB+2){
          this.colorData.right = '#5daf34'
        } else {
          this.colorData.right = '#FFFFFF'
        }
        that.indexUrl = indexBB;
      }

    },
    rightYY(){
      console.log("right")
      let that = this;
      if(that.indexUrl+3 > that.cpjsItem.length){
        return;
      } else {
        console.log(that.indexUrl)
        let indexBB = that.indexUrl+1;
        for (var i = 0; i < that.cpjsItem.length; i++) {
          let item = that.cpjsItem[i];
          console.log(item)
          console.log(i)
          console.log(indexBB)
          if(i>=(indexBB-1) && i<(indexBB+2)){
            item.showData = true;
          } else {
            item.showData = false;
          }
        }
        if(indexBB > 1){
          this.colorData.left = '#5daf34'
        } else {
          this.colorData.left = '#FFFFFF'
        }
        if(that.cpjsItem.length > indexBB+2){
          this.colorData.right = '#5daf34'
        } else {
          this.colorData.right = '#FFFFFF'
        }
        that.indexUrl = indexBB;
      }
    },
    cpjsCK(){
      this.$router.push('/product');
    },
    toCpjs(path){
      this.$router.push('/product?path='+path);
    }
  }
}
</script>

<style lang="scss" scoped>
.cpjs_item_img{
  width: 100%;
  aspect-ratio: 376/360;
  //border-bottom: 2px solid #5daf34;
  img{
    width: 100%;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
}
.cpjs_right_i{
  width: 45px;       /* 圆的宽度 */
  height: 45px;      /* 圆的高度 */
  //background-color: #5daf34; /* 圆的背景颜色 */
  border-radius: 50%; /* 将div变成圆形 */
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 200px;
  cursor: pointer;
}
.cpjs_left_i{
  width: 45px;       /* 圆的宽度 */
  height: 45px;      /* 圆的高度 */
  //background-color: #FFFFFF; /* 圆的背景颜色 */
  border-radius: 50%; /* 将div变成圆形 */
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 200px;
  cursor: pointer;
}
.cpjsContentBox{
  width: 100%;
  display: flex;
}
.cpjs_item_text1{
  font-family: SourceHanSansCN;
  font-size: 24px;
  color: #333333;
  letter-spacing: 0.51px;
  text-align: justify;
  margin-top: 30px;
  margin-right: 30px;
  margin-left: 30px;

}
.cpjs_item_text2{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  text-align: justify;
  line-height: 20px;
  margin-top: 30px;

  margin-right: 30px;
  margin-left: 30px;
}
.cpjs_item{
  width: 32%;
  margin-right: 10px;
  background-color: #FFFFFF;
  border-radius: 10px;
  aspect-ratio: 376/576;
}

.cpjsBox{
  width: 100%;
  margin: 0 auto;
  padding: 100px 0px;
  //background-image: url("https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg");
  background-size:100% 100%;
  display: flex;
  align-items: center;
}
.cpjs_ze{
  width: 61.25%;
  justify-content: space-between;
  margin: 0px auto 30px;
}
.cpjsHeader{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0px auto 30px;
}
.cpjs_left{
  font-family: SourceHanSansCN;
  font-size: 30px;
  color: #FFFFFF;
  letter-spacing: 0.64px;
  text-align: justify;
}
.cpjs_right{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 0;
  text-align: justify;
  cursor: pointer;
}

.warp {
  width: 402px*3-26;
  height: 576px;
  margin: 0 auto;
  overflow: hidden;

  ul {
    list-style: none;
    padding: 0;
    margin: 0 auto;

    &.ul-item {
      display: flex;

      .li-item {
        width: 376px;
        height: 576px;
        margin-right: 26px;
        line-height: 576px;
        background-color: #999;
        color: #fff;
        text-align: center;
        font-size: 30px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/image/cpjs.vue